import PropTypes from "prop-types";

import { Modal } from "antd";
import "./CustomModal.css";

/**
 * Modal reutilizable con estilos personalizados
 * @param {boolean} visible - Control de visibilidad
 * @param {string} title - Título del modal
 * @param {React.ReactNode} children - Contenido del modal
 * @param {function} onClose - Callback al cerrar
 * @param {function} onClose - Callback al cancelar accion
 * @param {function} onOk - Callback al confirmar
 * @param {string} okText - Texto del botón OK
 * @param {string} cancelText - Texto del botón Cancelar
 * @param {string} width - Ancho del modal
 * @param {boolean} centered - Centrar modal
 * @param {object} okButtonProps - Props adicionales del botón OK
 * @param {object} cancelButtonProps - Props adicionales del botón Cancelar
 * @param {boolean} headerShown - Mostrar/ocultar header
 * @param {boolean} showFooter - Mostrar/ocultar footer
 * @param {boolean} confirm - Indica si será tipo confirm
 * @param {React.ReactNode} customFooter - Footer personalizado
 */
export const CustomModal = ({
  visible,
  title,
  children,
  onClose,
  onCancel,
  onOk,
  okText = "Guardar",
  cancelText = "Cancelar",
  width = "450",
  centered = true,
  okButtonProps = {},
  cancelButtonProps = {},
  showFooter = true,
  customFooter = null,
  compact = false,
  confirm = false,
  headerShown = true,
  afterOpenChange,
  ...restProps
}) => {
  return (
    <Modal
      open={visible}
      title={<span className="custom-modal-title">{title}</span>}
      onCancel={onClose}
      onOk={onOk}
      okText={okText}
      cancelText={cancelText}
      centered={centered}
      width={width}
      afterOpenChange={afterOpenChange}
      footer={showFooter ? undefined : null}
      styles={{
        content: {
          padding: "0",
          borderRadius: "8px",
        },
        header: {
          width: "100%",
          padding: compact ? "12px 16px" : "16px 24px",
          borderBottom: headerShown && "1px solid rgba(193, 191, 191, 1)",
          marginBottom: "0",
        },
        body: {
          padding: compact ? "12px 16px" : "24px",
          overflowX: "hidden",
        },
        footer: customFooter
          ? null
          : {
              padding: compact ? "12px 16px" : "16px 24px",
              marginTop: "0",
              display: "flex",
              justifyContent: confirm ? "center" : "space-between",
              alignItems: "center",
              gap: "12px",
            },
      }}
      okButtonProps={{
        className: `custom-modal-btn-ok ${confirm && " custom-modal-btn-ok--confirm"}`,
        ...okButtonProps,
      }}
      cancelButtonProps={{
        className: "custom-modal-btn-cancel",
        onClick: onCancel || onClose,
        ...cancelButtonProps,
      }}
      {...restProps}
    >
      {customFooter ? (
        <>
          {children}
          <div className="custom-modal-footer">{customFooter}</div>
        </>
      ) : (
        children
      )}
    </Modal>
  );
};

CustomModal.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.node,
  children: PropTypes.node,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  centered: PropTypes.bool,
  okButtonProps: PropTypes.object,
  cancelButtonProps: PropTypes.object,
  showFooter: PropTypes.bool,
  customFooter: PropTypes.node,
  compact: PropTypes.bool,
  confirm: PropTypes.bool,
  headerShown: PropTypes.bool,
  afterOpenChange: PropTypes.func,
};
